module.exports = __webpack_public_path__ + "static/img/banner-culture.6974731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/culture/banner-culture.jpg
// module id = gDYp
// module chunks = 0